import { useEffect, useState } from 'react';
import Inputs from './components/Inputs';
import GridProvider from './components/GridProvider';
import { urls } from './api/urls';
import useHttp from '../../../hooks/use-http';
import Spinner from '../../UI/Modal/Spinner';
import { useTranslation } from 'react-i18next';
import { handleErrorMessage } from '../../../../shared/api/handleErrorMessage';
import toast from 'react-hot-toast';
import MuiDialog from '../../UI/MuiDialog/MuiDialog';
import { isFormValid } from './validation/isFormValid';

const INITIAL_VALUES = {
  id: 0,
  naziv: '',
  jm: '',
  cenaTehnicar: '',
  cenaInzenjer: '',
  cenaTehnicarIno: '',
  cenaInzenjerIno: '',
  tip: 0,
  nazivTipa: '',
};
const listaTipova = [
  {
    id: 1,
    vrednost: 'Rad',
  },
  {
    id: 2,
    vrednost: 'Transport',
  },
  {
    id: 3,
    vrednost: 'Trošak',
  },
];

const VrstaUsluge = ({ save, handleSave, novi, handleNovi }) => {
  const { t, i18n } = useTranslation();
  const { sendRequest, getData, data, isLoading } = useHttp('');
  const [formValues, setFormValues] = useState(INITIAL_VALUES);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [tipoviUsluga, setTipoviUsluga] = useState(listaTipova);

  const vratiKategorije = () => {
    sendRequest({ url: urls.GET_VRSTAUSLUGE });
  };
  const handleSaveData = async () => {
    if (isFormValid(formValues)) {
      return;
    }
    const config = {
      method: 'POST',
      url:
        formValues.id !== 0 ? urls.UPDATE_VRSTAUSLUGE : urls.INSERT_VRSTAUSLUGE,
      data: {
        ...formValues,
        cenaTehnicar: +formValues.cenaTehnicar,
        cenaInzenjer: +formValues.cenaInzenjer,
        cenaTehnicarIno: +formValues.cenaTehnicarIno,
        cenaInzenjerIno: +formValues.cenaInzenjerIno,
        idKorProm: +localStorage.idKorisnika,
      },
    };
    const result = await getData(config);
    if (result.id > 0) {
      vratiKategorije();
      setFormValues(INITIAL_VALUES);
      toast.success(
        formValues.id === 0
          ? 'Uspešan unos podatak'
          : 'Uspešna izmena podataka',
      );
      return;
    }
    toast.error(handleErrorMessage(result));
  };
  useEffect(() => {
    if (save) {
      handleSaveData();
      handleSave(false);
    }
  }, [save]);
  useEffect(() => {
    if (novi) {
      handleNovi(false);
      setFormValues(INITIAL_VALUES);
    }
  }, [novi]);

  useEffect(() => {
    vratiKategorije({ url: urls.GET_KATEGORIJE });
  }, []);
  const handleOpenDeleteDialog = (id) => {
    setFormValues((curr) => {
      return { ...curr, id: id };
    });
    setOpenDeleteDialog(true);
  };
  const handleCloseDelete = () => {
    setFormValues(INITIAL_VALUES);
    setOpenDeleteDialog(false);
  };
  const handleEditData = async (item) => {
    console.log(item);
    setFormValues(item);
  };
  const handleDelete = async () => {
    const config = {
      method: 'POST',
      url: urls.DELETE_VRSTAUSLUGE,
      data: { id: formValues.id },
    };
    const response = await getData(config);
    if (response > 0) {
      toast.success('Uspešano obrisan podatak');
      setFormValues(INITIAL_VALUES);
      setOpenDeleteDialog(false);
      vratiKategorije();
      return;
    }
    toast.error('Greška prilikom brisanja podatka');
  };
  return (
    <div>
      {' '}
      {isLoading && <Spinner />}
      <Inputs
        formValues={formValues}
        setFormValues={setFormValues}
        kategorijeData={tipoviUsluga}
      />
      <GridProvider
        data={data}
        handleOpenDeleteDialog={handleOpenDeleteDialog}
        handleEditData={handleEditData}
        loading={isLoading}
        tipovi={tipoviUsluga}
      />
      <MuiDialog
        maxWidth="sm"
        open={openDeleteDialog}
        title={t('warning')}
        text={t('warningDelete')}
        handleClose={handleCloseDelete}
        handleConfirm={handleDelete}
        deniedText="ZATVORI"
      />
    </div>
  );
};

export default VrstaUsluge;
